import Swiper from 'swiper';
import {Autoplay, EffectFade, Pagination, Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
const initSlider = () => {
  const bannerSwiper = new Swiper(".bannerSliderSwiper", {
    modules: [Autoplay, EffectFade],
    loop: true,
    speed: 2000,
    effect: "fade",
    centeredSlides: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
    },
  });

  const teaseSwiper = new Swiper(".testimonial-swiper", {
    modules: [Autoplay, EffectFade],
    loop: true,
    speed: 3000,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
  });
  /*
  const sliderV1 = new Swiper(".sliderV1-swiper", {
    modules: [Autoplay, Pagination, EffectFade, Navigation],
    loop: true,
    speed: 1000,
   // effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".testimonial-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".sliderV1-btn-next",
      prevEl: ".sliderV1-btn-prev",
    },
  });
  const sliderV2 = new Swiper(".sliderV2-swiper", {
    modules: [Autoplay, Pagination, EffectFade, Navigation],
    loop: true,
    speed: 1000,
    // effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".testimonial-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".sliderV2-btn-next",
      prevEl: ".sliderV2-btn-prev",
    },
  });
  const sliderV3 = new Swiper(".sliderV3-swiper", {
    modules: [Autoplay, Pagination, EffectFade, Navigation],
    loop: true,
    speed: 1000,
    // effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".sliderV3-btn-next",
      prevEl: ".sliderV3-btn-prev",
    },
  });
  const sliderSimple = new Swiper(".sliderSimple-swiper", {
    modules: [Autoplay, Pagination, EffectFade, Navigation],
    loop: true,
    speed: 1000,
    // effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".sliderSimple-pagination",
      clickable: true
    },
  }); */
};
export default initSlider;
